import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const FacilityUnitMicroData = ({
	storageUnits = [],
	vehicleUnits = [],
	facilityName,
	facilityUrl,
	facilityImageUrl = "",
	facilityId
}) => {
	const createProductSchemas = () => {
		const schemas = [];

		storageUnits.forEach((unit) => {
			schemas.push({
				"@context": "https://schema.org",
				"@type": "Product",
				"@id": facilityId,
				name: facilityName,
				description: `${unit.sizeText} Storage Unit - ${facilityName}`,
				productID: facilityId,
				url: facilityUrl,
				brand: {
					"@type": "Brand",
					name: facilityName
				},
				offers: {
					"@type": "Offer",
					price: unit.lowestPrice,
					priceCurrency: "USD",
					availability: "https://schema.org/InStock"
				},
				image: facilityImageUrl
			});
		});

		vehicleUnits.forEach((unit) => {
			schemas.push({
				"@context": "https://schema.org",
				"@type": "Product",
				"@id": facilityId,
				name: facilityName,
				description: `${unit.sizeText} Vehicle Storage - ${facilityName}`,
				productID: facilityId,
				url: facilityUrl,
				brand: {
					"@type": "Brand",
					name: facilityName
				},
				offers: {
					"@type": "Offer",
					price: unit.lowestPrice,
					priceCurrency: "USD",
					availability: "https://schema.org/InStock"
				},
				image: facilityImageUrl
			});
		});

		return schemas;
	};

	const productSchemas = createProductSchemas();

	return (
		<>
			{productSchemas.map((schema) => (
				<Schema
					key={schema["@id"]}
					schema={schema}
				/>
			))}
		</>
	);
};

FacilityUnitMicroData.propTypes = {
	storageUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			sizeText: PropTypes.string.isRequired,
			tierDescription: PropTypes.string,
			lowestPrice: PropTypes.number,
			url: PropTypes.string
		})
	),
	vehicleUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			sizeText: PropTypes.string.isRequired,
			tierDescription: PropTypes.string,
			lowestPrice: PropTypes.number,
			url: PropTypes.string
		})
	),
	facilityName: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityId: PropTypes.string.isRequired,
	facilityImageUrl: PropTypes.string
};

export default FacilityUnitMicroData;
